import { Input, Tooltip } from '@hawkins/components';
import { useEffect, useState } from 'react';

interface ProtectionInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  showRoundingTooltip?: boolean;
}

export const ProtectionInput = ({
  value,
  onChange,
  disabled = false,
  showRoundingTooltip = false,
}: ProtectionInputProps) => {
  const [input, setInput] = useState(value?.toString() ?? '');

  const [invalidInput, setInvalidInput] = useState(false);

  useEffect(() => {
    setInput(value?.toString() ?? '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setInput(inputValue);

    const numValue = Number(inputValue);
    setInvalidInput(
      (inputValue !== '' && isNaN(numValue)) || numValue < 0 || numValue > 100
    );
  };

  const handleBlur = () => {
    if (!invalidInput) {
      const parsedValue = input === '' ? 0 : parseFloat(input);
      // Update the input display to show the final value
      setInput(parsedValue.toString());
      onChange(parsedValue);
    }
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    // Prevent scrolling from changing the input value since it also moves the page
    if (document.activeElement === e.target) {
      (e.target as HTMLInputElement).blur();
    }
  };

  const inputComponent = (
    <Input
      type="number"
      label={'Protection'}
      value={input}
      endAdornment="%"
      onChange={handleChange}
      onBlur={handleBlur}
      onWheel={handleWheel}
      disabled={disabled}
      validationStatus={invalidInput ? 'error' : undefined}
      validationMessage={
        invalidInput ? 'Value must be between 0 and 100' : undefined
      }
    />
  );

  return showRoundingTooltip ? (
    <Tooltip
      label="Value may be rounded to ensure the framing decision has even numbers."
      placement="bottom"
    >
      {inputComponent}
    </Tooltip>
  ) : (
    inputComponent
  );
};
